import styled from 'styled-components';
import Edit from '@material-ui/icons/Edit';

import THEME from '../../../../../../../constants/theme';

export const Container = styled.div``;

export const EditButton = styled(Edit)`
  font-size: 13px !important;
  margin-left: 5px;
`;

export const Text = styled.span`
  color: ${THEME.bobBlack};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
`;

export const HoverText = styled(Text)`
  &:hover {
    background: ${THEME.lightGrey};
    border-radius: 4px;
    cursor: pointer;
    padding: 2px;
  }
`;

export const style = {
  input: {
    border      : `1px solid ${THEME.primary}`,
    borderRadius: 4,
    fontFamily  : 'Montserrat',
    fontSize    : 14,
    fontWeight  : 500,
  },
};
